import { render, staticRenderFns } from "./CostElementToolbar.vue?vue&type=template&id=8963dbc4&scoped=true&"
import script from "./CostElementToolbar.vue?vue&type=script&lang=js&"
export * from "./CostElementToolbar.vue?vue&type=script&lang=js&"
import style0 from "./CostElementToolbar.vue?vue&type=style&index=0&id=8963dbc4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8963dbc4",
  null
  
)

export default component.exports